export enum OrganizationTypeEnum {
  BRANCH = 'branch',
  PPZ = 'ppz',
  PARTNER = 'partner',
  DPZ = 'dpz',
}
